import {
    Flex,
    Container,
    Stack,
    Accordion,
} from '@chakra-ui/react'

//   import TextDivider from './QuestionsAndAnswers/TextDivider'
import TextDivider from './TextDivider'
import FaqItem from './FaqItem'

import Faq from '../../../Config/json/faq.json'

const FaqList = ({ query, setQuery }) => {

    const handleSearch = (item) => {
        if (query == '') {
            return item
        } else if (item.question.toLowerCase().includes(query.toLowerCase())) {
            return item
        } else if (item.answer.toLowerCase().includes(query.toLowerCase())) {
            return item
        }
    }

    return (
        <Flex
            w={'full'}
            h={'40vg'}
            pt={5}
            pb={'10vh'}
        >
            <Container
                maxW={'3xl'}
            >
                <Stack direction={'column'} textAlign={'center'} spacing={5}>

                    <TextDivider label={'General Questions'} />

                    <Accordion allowToggle>

                        {
                            Faq[0]['general_questions'].filter(handleSearch).map(item => {
                                return (
                                    <FaqItem question={item.question} answer={item.answer} key={item.question} />
                                )
                            })
                        }

                    </Accordion>

                    <TextDivider label={'DaddysTeach - Homework Q&A'} />

                    <Accordion allowToggle>

                        {
                            Faq[0]['ask'].filter(handleSearch).map(item => {
                                return (
                                    <FaqItem question={item.question} answer={item.answer} key={item.question} />
                                )
                            })
                        }

                    </Accordion>


                    <TextDivider label={'DaddysTeach - Scholarships'} />

                    <Accordion allowToggle>

                        {
                            Faq[0]['scholarships'].filter(handleSearch).map(item => {
                                return (
                                    <FaqItem question={item.question} answer={item.answer} key={item.question} />
                                )
                            })
                        }

                    </Accordion>
                </Stack>
            </Container>
        </Flex>
    )
}

export default FaqList